import * as React from 'react'
import HmeHeader from '../Header/HmeHeader'
import SettingsHeader from '../Header/SettingsHeader'
import AdminSubHeader from '../Header/adminSubHeader'
import Footer from '../Footer/Footer'
import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import './Common.css'
import Modal from 'react-modal'
import 'url-search-params-polyfill'
import Api from '../../Api'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'

import Idle from 'react-idle'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '10px',
    width: '255px'
  }
}

export default class Layout extends React.Component {
  constructor () {
    super()
    this.authService = new AuthenticationService(Config.authBaseUrl)

    this.state = {
      modalIsOpen: false,
      signoutTime: Config.waitTime,
      language: languageSettings.getCurrentLanguage()
    }
    this.api = new Api()

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.idToken = this.authService.getIdToken()
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.timer = null
  }
  componentDidMount () {
    this.setUserContext()
  }

  componentWillMount () {
    this.prepareProfile()
  }

  prepareProfile () {
    const params = new URLSearchParams(this.props.Params.location.search)
    const contextToken = params.get('token') ? params.get('token') : null
    const admin = params.get('a') == 'true'
    const uuid = params.get('uuid') ? params.get('uuid') : null
    const duid = params.get('duid') ? params.get('duid') : null
    const idToken = params.get('atoken') ? params.get('atoken') : null
    const userId = params.get('memail') ? params.get('memail') : null
    const GroupUID = params.get('GroupUID') ? params.get('GroupUID') : null
    const isDefault = params.get('isDefault') ? params.get('isDefault') : null
    const ia = params.get('ia') ? params.get('ia') : null
    let headers = {}
    if (contextToken) {
      this.authService.setToken(contextToken, admin)
    }
    if (idToken) {
      this.authService.setTokens(idToken, contextToken, admin)
      headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + idToken
      }
    }

    
    let path = window.location.pathname;


    if (userId) {
      let user = {
        username: userId
      }
      let url = Config.authBaseUrl + Config.tokenPath
      this.api.postData(url, user, data => {
        if (data && data.accessToken) {
          this.authService.setTokens(this.authService.getIdToken(), data.accessToken,
            this.authService.isAdmin())
          if (uuid) {
            path += '?uuid=' + uuid
          }// If is redirecting to LB Group page; Params for redirecting after they get stripped from coldfusion login
          if (GroupUID && isDefault && ia){
            path += '?GroupUID=' + GroupUID + '&SsDefault=' + isDefault + '&ia=0'
          }
          window.location.href = path
        }
      }, error => {
        console.log(error);
      }, headers)
    } else if (contextToken) {
      if (uuid) {
        path += '?uuid=' + uuid
      }
      if (duid) {
        path += '?duid=' + duid
      }// If is redirecting to LB Group page; Params for redirecting after they get stripped from coldfusion login
      if (GroupUID && isDefault && ia){
        path += '?GroupUID=' + GroupUID + '&SsDefault=' + isDefault + '&ia=0'
      }
      window.location.href = path
    }

    if (uuid) {
      this.authService.setUUID(uuid)
    }

    if (!this.authService.isLoggedIn()) {
      this.authService.setAdmin(window.location.pathname == '/admin' ||
                window.location.pathname.startsWith('/admin/'))
    }
  }

  openModal () {
    this.setState({ modalIsOpen: true })
  }

  closeModal () {
    clearTimeout(this.state.timer)
    this.setState({ modalIsOpen: false })
  }
  setUserContext () {
    let ctxToken = this.authService.getToken()
    if (ctxToken) {
      let ctxUser = this.authService.getProfile()
      if (ctxUser) {
        this.state.contextUser = ctxUser
      }
    }
    let loggedInUser = this.authService.getProfile()
    if (loggedInUser) {
      this.state.loggedInUser = loggedInUser
    }
    this.setState(this.state)
  }

  showPopUp (e) {
    if (this.authService.isLoggedIn()) {
      this.state = {
        modalIsOpen: true
      }
      clearTimeout(this.state.timer)
      this.setState(this.state)
      this.state.timer = setTimeout(function () {
        if (this.state.modalIsOpen) {
          if (this.authService.isMasquerade()) {
            let url = Config.adminColdFusionUrl + '?token=' + this.state.idToken
            this.authService.clear();
            window.location.href = url
          } else {
            window.location.href = '/logout'
          }
        } else {
          clearTimeout(this.state.timer)
        }
      }.bind(this), Config.waitTime)
      this.setState(this.state)
    }
  }

  render () {
    const { children } = this.props
    const { language } = this.state

    let contextUserEmail = this.authService.getProfile()
    return (
      <div>
        <Idle
          timeout={Config.idleTime}
          onChange={({idle}) => {
            if (idle) {
              this.showPopUp(this)
            }
          }
          }
        />
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          ariaHideApp={false}
        >
          <header className='modalHeader'> {t[language].AutoLogout} <button onClick={this.closeModal}> X </button> </header>
          <div className={this.authService.isMasquerade() ? 'show' : 'hidden'}>
            <span className='autoSignOutContent'>{t[language].YouAreCurrentlyViewing}  {contextUserEmail.User_EmailAddress ? contextUserEmail.User_EmailAddress : contextUserEmail.name} </span>
            <button className='continueButton' onClick={this.closeModal}>{t[language].ContinueViewingAs} {contextUserEmail.User_EmailAddress ? contextUserEmail.User_EmailAddress : contextUserEmail.name} </button>
          </div>
          <div className={!this.authService.isMasquerade() ? 'show' : 'hidden'}>
            <span className='autoSignOutContent'>{t[language].YouAreAboutToBeSignedOut}</span>
            <button className='continueButton' onClick={this.closeModal}>{t[language].StayLoggedIn}</button>
          </div>
        </Modal>
        <HmeHeader />
        <AdminSubHeader />
        <div><SettingsHeader /></div>
        <div className={(window.location.pathname.indexOf('/help') !== -1 ? 'helpSection' : (window.location.pathname.indexOf('/welcome') !== -1 ? (this.authService.isAdmin() ? 'welcomeAdmin' : 'welcome') : 'hmeBody'))}>
          {children}
        </div>
        <Footer />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Layout.js